// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","nav":"Header_nav__IIF23","link":"Header_link__qAkBV"};